import { BaseError } from "./BaseError";

export class ConflictError extends BaseError {
  readonly status = 409;
}
